export type Link = {
  length: string;
  to: string;
};

export enum distanceType {
  BY_LINK_LENGTH = "BY_LINK_LENGTH",
  BY_WEIGHT = "BY_WEIGHT",
  BY_COORDINATES = "BY_COORDINATES",
}
